import gql from 'graphql-tag';

const announcements = gql`
  query announcements(
    $type: ANNOUNCEMENT_TYPE
    $providerName: String
    $isIncludedUserAnnoucement: Boolean
    $platform: ANNOUNCEMENT_PLATFORM
    $limit: Int
    $offset: Int
  ) {
    announcements(
      type: $type
      providerName: $providerName
      isIncludedUserAnnoucement: $isIncludedUserAnnoucement
      platform: $platform
      limit: $limit
      offset: $offset
    ) {
      id
      title
      category
      detail {
        content
        type
        contentV2 {
          ... on AnnouncementSlideContent {
            slideContent {
              title
              imageUrl
              description
              button {
                title
                href
              }
            }
          }
        }
      }
      announcedBy
      publishedTime
      relationType
      courseCode
      courseTitle
      createdAt
    }
  }
`;

export { announcements };
